import Vue from "vue";
import App from "./App.vue";
import router from "./pages/router";
import store from "./store";
import TextareaAutosize from 'vue-textarea-autosize';
import vSelect from 'vue-select';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import Toasted from 'vue-toasted';
import VueMask from 'v-mask';
import VueRoughNotation from "vue-rough-notation";
import PerfectScrollbar from 'vue2-perfect-scrollbar';


Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
	  el.clickOutsideEvent = function (event) {
		// here I check that click was outside the el and his children
		if (!(el == event.target || el.contains(event.target))) {
		  // and if it did, call method provided in attribute value
		  vnode.context[binding.expression](event);
		}
	  };
	  document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
	  document.body.removeEventListener('click', el.clickOutsideEvent)
	},
  });

Vue.config.productionTip = false;

Vue.filter('date', function(value) {
	var d = parse(value, 'yyyy-MM-dd', new Date());
	if (value) {
		return format(d, 'MM/dd/yyyy');
	}
});

Vue.filter('detailed_date', function(value) {
	var d = parse(value, 'yyyy-MM-dd HH:mm:s', new Date());
	if (value) {
		return format(d, 'MM/dd/yyyy h:mm a');
	}
});

Vue.filter('publish_date', function(value) {
	var d = parse(value, 'yyyy-MM-dd HH:mm:s', new Date());
	if (value) {
		return format(d, 'MMM. d, yyyy');
	}
});

Vue.filter('paypal_date', function(value) {
	var d = parse(value, 'MMddyyyy', new Date());
	if (value) {
		return format(d, 'MM/dd/yyyy');
	}
});

Vue.use(VueMask);
Vue.use(TextareaAutosize);
Vue.use(Toasted);
Vue.use(VueRoughNotation);
Vue.use(PerfectScrollbar);

Vue.component('v-select', vSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
